import React, { useState } from "react";
import { Col, FormGroup, Input, Label } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Btn, H2, P, Image } from "../AbstractElements";
import { baseUrl, dynamicImage } from "../Utils";
import {
  EmailAddress,
  ForgotPassword,
  Password,
  SignIn,
  SignInAccount,
} from "../Utils/Constants";
import axios from "axios";
import {
  useForm,
  Controller,
  SubmitHandler,
  FieldError,
} from "react-hook-form";
import { useAuth } from "../Context/AuthContext";

type FormData = {
  email: string;
  password: string;
};


export default function SignInForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setAuthData } = useAuth();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  // Dummy Data for Logic - override for testing if no backend
  // const [email, setEmail] = useState("admin@gmail.com");
  // const [password, setPassword] = useState("admin#123");

  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => setPasswordVisible(!isPasswordVisible);

  const onSubmit = async (data: FormData) => {
    setLoading(true); // Start loading
    try {
      const response = await axios.post(`${baseUrl}login`, {
        email: data.email,
        password: data.password,
      });

      const token = response.data.token;

      localStorage.setItem("token", token);
      localStorage.setItem("login", JSON.stringify(true));

      // Use context instead of localStorage for role and permissions
      if (response.data.role && response.data.permissions) {
        setAuthData(response.data.role, response.data.permissions, {
          name: response.data.name,
          email: response.data.email,
          role: response.data.role,
          profile_image: response.data.profile_image
        });
      }

      toast.success("Login Success!");

      navigate(`${process.env.PUBLIC_URL}/dashboard`);
    } catch (error: any) {
      console.error("Login error:", error);
      const errorMessage = error.response?.data?.message || "Login error";
      toast.error(errorMessage);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div>
      <div>
        <Link className="logo" to="#">
          <Image
            className="img-fluid for-light m-auto"
            src={dynamicImage(`logo/logo1.webp`)}
            alt="loginpage"
            style={{ height: '50px' }}
          />
          <Image
            className="img-fluid for-dark"
            src={dynamicImage(`logo/logo1.webp`)}
            alt="loginpage"
            style={{ height: '50px' }}
          />
        </Link>
      </div>
      <div className="login-main">
        <form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
          <H2 className="text-center">{SignInAccount}</H2>
          <P className="text-center">
            {"Enter your email & password to login"}
          </P>

          <FormGroup>
            <Col>
              <Label>{EmailAddress}</Label>
            </Col>
            <Controller
              name="email"
              control={control}
              defaultValue=""
              rules={{ required: "Please enter your email" }}
              render={({ field }) => (
                <Input
                  type="email"
                  {...field}
                  placeholder="Email"
                  invalid={!!errors.email} autoComplete="off"
                />
              )}
            />
            {errors.email && (
              <div className="text-danger">
                {(errors.email as FieldError).message}
              </div>
            )}
          </FormGroup>

          <FormGroup>
            <Col>
              <Label>{Password}</Label>
            </Col>
            <Controller
              name="password"
              control={control}
              defaultValue=""
              rules={{ required: "Please enter your password" }}
              render={({ field }) => (
                <div className="form-input position-relative">
                  <Input
                    type={isPasswordVisible ? "text" : "password"}
                    {...field}
                    placeholder="Password"
                    invalid={!!errors.password} autoComplete="off"
                  />
                  <div className="show-hide" onClick={togglePasswordVisibility}>
                    <span className={!isPasswordVisible ? "show" : ""}></span>
                  </div>
                </div>
              )}
            />
            {errors.password && (
              <div className="text-danger">
                {(errors.password as FieldError).message}
              </div>
            )}
          </FormGroup>

          <FormGroup className="mb-0 checkbox-checked">
            <Link className="link" to={`${process.env.PUBLIC_URL}/forgot-password`}>
              {ForgotPassword}
            </Link>

            <div className="text-end mt-3">
              <Btn
                color="primary"
                className="w-100"
                block
                type="submit"
                disabled={loading}
              >
                {loading ? "Signing in..." : SignIn}
              </Btn>
            </div>
          </FormGroup>
          <div className="text-center mt-3" style={{ display: "none" }}>
            <a
              href="/privacy_policy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-underline"
            >
              Privacy Policy
            </a>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
}